module.exports = __webpack_public_path__ + "img/slot-machine-logo.5d97bee3.png";